<template>
    <div class="col-12">
        <ul class="pagination align-items-center justify-content-center" v-if="pages">
            <li class="page-item" :class="{ disabled: pagination.currentPage <= 1 }">
                <a class="page-link" @click.prevent="setPage(pagination.currentPage - 1)">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                </a>
            </li>
            <li class="page-item" v-for="page in pages" :key="page" :class="isCurrentPage(page) ? 'active' : ''">
                <a class="page-link" @click="setPage(page)" v-if="page >= 0">{{page}}</a>
                <p v-if="page === -1" class="paginate-space">...</p>
            </li>
            <li class="page-item" :class="{ disabled: pagination.currentPage >= pagination.pageCount }">
                <a class="page-link" @click.prevent="setPage(pagination.currentPage + 1)">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
const MAX_SHOWING_NEAR_CURRENT_PAGE = 5;
export default {
    props: ['pagination'],
    methods: {
        isCurrentPage(page){
            return this.pagination.currentPage === page
        },
        setPage(page) {
            this.pagination.currentPage = page;
            this.$emit('paginate');
        }
    },
    computed: {
        pages() {
            let pages = [];
            const lastPage = this.pagination.pageCount;
            const fistPage = 1;
            // 1, 2 , 3, 4, 5, 6, 7, 8, 9, 10
            // case 1: show all
            if (this.pagination.pageCount === 0) {
                pages = [1];
                return ;
            }
            const allPages = Array(this.pagination.pageCount).fill(0).map((x, i) => i + 1);
            if (this.pagination.pageCount <= MAX_SHOWING_NEAR_CURRENT_PAGE) {
                pages = allPages;
                return pages;
            }
            // case 2:  page count more than max showing page
            // 1 ...  7 8 9 10 11 ... 100
            // case 2.1
            // 1 2 3 4 5 ... 100
            const numberBeforeCurrentPage = Math.floor(MAX_SHOWING_NEAR_CURRENT_PAGE / 2);
            const startIndexSlice = Math.max(0, Math.min(this.pagination.pageCount - MAX_SHOWING_NEAR_CURRENT_PAGE, this.pagination.currentPage - numberBeforeCurrentPage - 1));
            const endIndexSlice = Math.min(this.pagination.pageCount, startIndexSlice + MAX_SHOWING_NEAR_CURRENT_PAGE);
            const middlePages = allPages.slice(startIndexSlice, endIndexSlice);
            pages = pages.concat(middlePages);
            if(pages[0] !== fistPage){
                if(pages[0] - 1 > fistPage) {
                    pages = [fistPage].concat([-1]).concat(pages);
                } else {
                    pages =  [fistPage].concat(pages);
                }
            }
            if (pages[pages.length - 1] !== lastPage) {
                if(pages[pages.length - 1] + 1 < lastPage) {
                    pages.push(-1);
                }
                pages.push(lastPage);
            }
            // console.log(pages);
            return pages;
        },
    }
}
</script>

<style scoped>
    li.page-item {
        cursor: pointer;
    }
</style>
